import { NgModule } from '@angular/core';
import { environment } from '@et/environment';
import { getDocPrepServiceDomain } from '@et/utils';
import {
  packetsApiModule,
  Configuration,
  ConfigurationParameters,
} from '@escrowtab/packets-api-client';
import {
  docprepApiModule,
  Configuration as DocPrepConfiguration,
  ConfigurationParameters as DocPrepConfigurationParameters,
} from '@escrowtab/docprep-api-client';

function packetConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.packetService.domain,
  };
  return new Configuration(params);
}

function docPrepConfigFactory(): DocPrepConfiguration {
  const params: DocPrepConfigurationParameters = {
    basePath: getDocPrepServiceDomain(),
  };
  return new DocPrepConfiguration(params);
}

@NgModule({
  imports: [
    packetsApiModule.forRoot(packetConfigFactory),
    docprepApiModule.forRoot(docPrepConfigFactory),
  ],
  exports: [packetsApiModule, docprepApiModule],
})
export class AppApiModule {}
